import '../../resources/css/frame/MainMenu.scss';
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { doActivePage, doChangeSimpleMode, doChangeDetailMode } from '../../actions/menu/index';
import Loading from '../../components/common/Loading';

class MainMenu extends Component {
  // constructor(props) {
  //   super(props);
  // }

  selectMenu = (name) => {
    const { doActivePage } = this.props;
    doActivePage(name);
  }

  renderToggleMenuMode = (mode, iconPre, text, iconMin, iconMax) => {

    const { doChangeSimpleMode, doChangeDetailMode } = this.props;

    const areaIconPre = <span className={ iconPre }></span>;
    const areaIconMinClass = iconMin + ' ml-auto';
    const areaIconMin = (
      <span className={ areaIconMinClass } onClick={ doChangeSimpleMode }></span>
    );
    const areaIconMax = (
      <span className={ iconMax } onClick={ doChangeDetailMode }></span>
    )

    if (mode === 'simple-mode') {
      return (
        <Nav className="main-item" variant="main-title">
          { areaIconMax }
        </Nav>
      );
    } else {
      return (
        <Nav className="main-item" variant="main-title">
          { areaIconPre }
          { text }
          { areaIconMin }
        </Nav>
      );
    }
  }

  renderMainItem = (mode, icon, text) => {
    if (mode === 'simple-mode') {
      return (
        <Nav variant="main-item">
          <span className={ icon }></span>
          <div className="line"></div>
        </Nav>
      );
    } else {
      return (
        <Nav variant="main-item">
          <span className={ icon }></span>
          <div className="line">{ text }</div>
        </Nav>
      );
    }    
  }  

  renderSubItem = (mode, name, icon, text) => {
    if (mode === 'simple-mode') {
      return (
        <Nav.Link onSelect={() => this.selectMenu(name)} className="sub-item" eventKey={name}>
            <span className={icon}></span>
        </Nav.Link>
      );
    } else {
      return (             
        <Nav.Link onSelect={() => this.selectMenu(name)} className="sub-item" eventKey={name}>
          <span className={icon}></span>
          {text}
        </Nav.Link>
      );
    }    
  }

  render() {
    const { displayMode, activePage } = this.props;

    if (!activePage) {
      // return loading if no has active page
      return (
        <Loading loading={true}></Loading>
      )
    }

    const toggleMenuMode = this.renderToggleMenuMode(displayMode, 'icon-menu','MENU', 'icon-minimize', 'icon-maximize');
    const toggleDeviceList = this.renderMainItem(displayMode, 'icon-arrow-down-white', 'RangeHood');
    const toggleDeviceMonitor = this.renderMainItem(displayMode, 'icon-arrow-down-white', 'Maintenance');

    const navHoodList = this.renderSubItem(displayMode, 'HoodList', 'icon-device-list', 'Hood List');
    const navHoodMonitor = this.renderSubItem(displayMode, 'HoodMonitor', 'icon-end-device-monitor', 'Hood Monitor');
    const navHoodModeList = this.renderSubItem(displayMode, 'HoodModeList', 'icon-model-type', 'Hood Model');
    const navCompanyInfo = this.renderSubItem(displayMode, 'CompanyInfo', 'icon-info', 'Pacific Info');
    const navAccount = this.renderSubItem(displayMode, 'AccountList', 'icon-account', 'Account');
    const navCloudAccount = this.renderSubItem(displayMode, 'CloudAccountList', 'icon-cloud-account', 'Cloud Account');

    return (
      <Nav defaultActiveKey={activePage} variant="main-menu" className="main-menu flex-column">
        { toggleMenuMode }
        { toggleDeviceList }
        <div className="sub-menu">
          { navHoodList }
          { navHoodMonitor }
        </div>
        { toggleDeviceMonitor }
        <div className="sub-menu">
          { navHoodModeList }
          { navCompanyInfo }
          { navAccount }
          { navCloudAccount }
        </div>
      </Nav>
   )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    displayMode: state.menuReducers.displayMode,
    activePage: state.menuReducers.activePage
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { doActivePage, doChangeSimpleMode, doChangeDetailMode }
)(MainMenu))